import { styled, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
export const primary = "#E77843";
export const labelColor = "#2E2E30";
export const black = "#131313";
export const filedBorderColor = "rgba(19, 19, 19, 0.20)";
export const white = "#FFFFFF";

export const useCommonStyles = makeStyles()((theme, color) => ({
  field: {
    width: "100%",
    "& div": {
      borderRadius: "10px",
      color: black,
      borderColor: `1px solid ${filedBorderColor}`,
    },
    "& input": {
      fontWeight: 500,
      padding: "10px 15px",
    },
    "& button svg": {
      color: "#D9D9D9",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        border: `1px solid ${filedBorderColor}`,
      },
      "&:hover fieldset": {
        borderColor: filedBorderColor,
      },
    },
  },
  option: {
    marginLeft: 3,
    color: "black",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    "&.Mui-focused": {
      backgroundColor: "#f0f0f0",
    },
  },
  label: {
    // color: labelColor,
    // fontSize: "14px",
    // fontWeight: 500,
    // textTransform: "capitalize",
    // marginBottom: "8px",
  },
  customPagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    "& .MuiPagination-ul": {
      gap: "10px",
      [theme.breakpoints.down(420)]: {
        gap: "4px",
      },
    },
    "& .MuiPaginationItem-root": {
      border: "none",
      color: "#584F4F",
      fontSize: "16px",
      fontWeight: 500,
    },
    "& .Mui-selected": {
      backgroundColor: "transparent !important",
      color: "#0B2B54",
      border: "none",
      fontWeight: 700,
    },
    "& .Mui-disabled": {
      color: "#584F4F !important",
      border: "none",
    },
    "& .MuiPaginationItem-previousNext": {
      backgroundColor: "transparent !important",
      color: "#0B2B54",
      border: "none",
    },
    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "transparent !important",
      color: "#0B2B54",
      fontWeight: 700,
    },
    "& .Mui-selected:hover": {
      backgroundColor: "transparent !important",
      color: "#0B2B54",
      fontWeight: 700,
    },
  },
  radioButton: {
    "&.MuiFormControlLabel-root": {
      color: "#8F8F8F",
      // marginTop: "-18px",
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: 500,
        textTransform: "capitalize",
      },
      "& .MuiSvgIcon-root": {
        // color: "#D0D0D0",
        height: "20px",
        width: "20px",
      },
    },
  },
  checkBox: {
    "&.MuiFormControlLabel-root": {
      // color: "#8F8F8F",
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: 500,
        // color: "#8F8F8F",
      },
      "& .MuiSvgIcon-root": {
        color: "#D0D0D0",
        height: "18px",
        width: "18px",
        borderRadius: "2px",
      },
    },
  },
  mainBox: {
    backgroundColor: "#FFFFFFCC",
    borderRadius: "30px",
    boxShadow: "13px -5px 30px 0px rgba(29, 97, 205, 0.10)",
  },
  mainBoxGrey: {
    backgroundColor: "rgba(217, 217, 217, 0.5)",
    borderRadius: "30px",
  },
  saveButton: {
    color: "#FFFFFF",
    backgroundColor: "#E77843",
    borderRadius: "10px",
    padding: "8px 2rem",
    fontSize: "14px",
    fontWeight: 700,
    fontFamily: "Satoshi-Bold",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#E77843",
    },
  },
  cancelButton: {
    color: "#131313",
    backgroundColor: "transparent",
    borderRadius: "10px",
    padding: "8px 1.5rem",
    fontSize: "14px",
    fontFamily: "Satoshi-Bold",
    fontWeight: 700,
    border: "1px solid #D0D0D0",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  downloadButton: {
    color: "#E77843",
    backgroundColor: "#FCEEE8",
    borderRadius: "10px",
    padding: "8px 1.5rem",
    fontFamily: "Satoshi-Bold",
    fontSize: "14px",
    fontWeight: 700,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#FCEEE8",
    },
  },
  dialog_Main: {
    "& .MuiDialog-paper.MuiPaper-rounded": {
      overflow: "hidden",
      margin: "30px",
      position: "absolute",
      padding: "30px",
      borderRadius: "30px",
      [theme.breakpoints.down("sm")]: {
        width: "80vw",
        margin: "12px",
        borderRadius: "20px",
      },
    },
  },
  hideScrollbar: {
    maxHeight: "70vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  avatar: {
    height: "42px",
    width: "42px",
    objectFit: "cover",
    borderRadius: "50%",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontFamily: "Satoshi-Bold",
}));


export const categoryNameOptions = [
  { id: 1, name: "Base Paper" },
  { id: 2, name: "Film" },
  { id: 3, name: "Chemical" },
  { id: 4, name: "Ink" },
  { id: 5, name: "Packaging Material" },
  { id: 6, name: "Other" },
];
export const POTypeOptions = [
  { id: 1, name: "Local" },
  { id: 2, name: "Export" },
];

export const rawMaterialOption = [
  { id: 1, name: "Paper" },
  { id: 2, name: "Ink" },
  { id: 3, name: "Chemical" },
];

export const salutationOptions = [
  { id: 1, name: "Mr" },
  { id: 2, name: "Ms" },
  { id: 3, name: "Mrs" },
  { id: 4, name: "Miss" }
];

export const monthsOption = [
  {
    id: 4,
    name: "April",
  },
  {
    id: 5,
    name: "May",
  },
  {
    id: 6,
    name: "June",
  },
  {
    id: 7,
    name: "July",
  },
  {
    id: 8,
    name: "August",
  },
  {
    id: 9,
    name: "September",
  },
  {
    id: 10,
    name: "October",
  },
  {
    id: 11,
    name: "November",
  },
  {
    id: 12,
    name: "December",
  },
  {
    id: 1,
    name: "January",
  },
  {
    id: 2,
    name: "February",
  },
  {
    id: 3,
    name: "March",
  },
];

export const businessTypeOption = [
  { id: 1, name: "Traders" },
  { id: 2, name: "Service Provider" },
  { id: 3, name: "Manufacture" },
];


export const paperTypeOptions = [
  { id: 1, name: "MGK" },
  { id: 2, name: "CCK" },
  { id: 3, name: "Glassine" },
  { id: 4, name: "Other" },
];

export const colorOptions = [
  { id: 1, name: "White" },
  { id: 2, name: "Yellow" },
  { id: 3, name: "Blue" },
  { id: 4, name: "Other" },
];

export const ChemicalUnitOptions = [
  { id: 1, name: "Kg" },
  { id: 2, name: "Gm" },
];



export const formatTextWithLineBreaks = (text) => {
  return text.split("\n").map((item, index) => (
    <React.Fragment key={index}>
      {item}
      <br />
    </React.Fragment>
  ));
};

export const localImportOption = [
  { id: 1, name: "Local" },
  { id: 2, name: "Import" },
];

export const currencyOptions = [
  { name: "INR", symbol: "₹" },
  { name: "USD", symbol: "$" },
  { name: "EUR", symbol: "€" },
];
